<template>
  <div class="my_img_button_layer">
    <div :class="type == 'two_level' ? 'set_two_level' : 'set_one_level'">
      <p class="tips_left">
        <el-popover
          v-if="iconIsShow == 'left'"
          placement="top-start"
          popper-class="popover_style"
          :width="tipsWidth"
          trigger="hover"
          :content="tips"
          transition="zoom"
        >
          <span
            class="icon_info"
            slot="reference"
          >?</span>
        </el-popover>
      </p>
      <span
        class="title"
        v-text="title"
        :style="{
          width: !Number.isNaN(Number(titleWidth)) ? titleWidth + 'px' : titleWidth
        }"
      ></span>
      <el-button
        size="small"
        class="module"
        v-if="img_url == '' || button_type == 2 || button_type == 3"
        v-text="buttonTitle"
        :disabled="disabled"
        @click="uploadImg"
        style="cursor: pointer"
      ></el-button>
      <el-popover
        v-if="iconIsShow == 'right'"
        placement="top-start"
        popper-class="popover_style"
        :width="tipsWidth"
        trigger="hover"
        :content="tips"
      >
        <span
          class="icon_info icon_info_right"
          slot="reference"
        >?</span>
      </el-popover>
      <div
        class="jz_editor jz_background__editor"
        v-if="img_url !== '' && button_type == 1"
      >
        <div class="jz_img">
          <img
            :src="img_url"
            class="jz_img_item"
          />
        </div>
        <div class="jz_editor_layer">
          <i
            class="jz_editor_item jz_editor_del"
            @click="delPic"
          ></i>
          <a
            :title="$t('components_my_img_button_index_2316')"
            class="jz_background__editor_item_jump"
            :href="img_url"
            target="_blank"
          ></a>
          <i
            :title="$t('components_my_img_button_index_2317')"
            class="jz_background__editor_item_upload"
            @click="uploadImg"
          ></i>
        </div>
      </div>
      <a
        :href="img_url"
        target="_blank"
        v-if="img_url !== '' && button_type == 2"
        class="fileName"
        v-text="file_name"
      ></a>
    </div>
    <div
      class="jz_editor jz_background__editor"
      style="margin-left:74px"
      v-if="img_url !== '' && button_type == 3"
    >
      <div class="jz_img">
        <img
          :src="img_url"
          class="jz_img_item"
        />
      </div>
      <div class="jz_editor_layer">
        <i
          class="jz_editor_item jz_editor_del"
          @click="delPic"
        ></i>
        <a
          class="jz_background__editor_item_jump_new"
          :href="img_url"
          target="_blank"
        ></a>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: 'my_img_button_index',
  props: {
    titleWidth: {
      type: String,
      default: '40'
    },
    title: { // 组件的标题
      type: String,
      default: ''
    },
    buttonTitle: {
      type: String,
      default: i18n.t('view_back_top_edit_97')
    },
    type: { // 组件的类型  one_level 一级组件 two_level 二级组件
      type: String,
      default: 'two_level'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    iconIsShow: { // 图标位置（'' 不显示 left 左边显示 right 右边显示）
      type: String,
      default: ''
    },
    tips: { // 图标提示信息
      type: String,
      default: ''
    },
    tipsWidth: {
      type: String,
      default: '310'
    },
    imgUrl: {
      type: String
    },
    fileName: {
      type: String,
      default: ''
    },
    buttonType: {
      type: Number,
      default: 1 // 1、预览和编辑 2、一个 预览
    },
  },
  data () {
    return {
      img_url: this.imgUrl,
      button_type: this.buttonType,
      file_name: this.fileName
    }
  },
  mounted () {
  },
  watch: {
    img_url (val) {
      this.$emit('update:imgUrl', val);//双向数据绑定
    },
    'imgUrl' (val) {
      this.img_url = val
    },
    file_name (val) {
      this.$emit('update:fileName', val)
    },
    'fileName' (val) {
      this.file_name = val
    }
  },
  computed: {
  },
  methods: {
    uploadImg () {
      this.$emit('uploadImg')
    },
    delPic () {
      this.img_url = ''
    }
  }
}
</script>

<style scoped type="text/css" lang="scss">
.icon_info_right {
  margin-left: 5px;
}
.jz_background__editor {
  width: 120px;
  height: 70px !important;
  margin-left: 10px;
}
.jz_editor {
  position: relative;
  height: 100%;
}
.jz_img {
  box-sizing: border-box;
  height: 100%;
  border: 1px solid #e7e7eb;
  text-align: center;
  font-size: 0;
  line-height: 0;
}
.jz_background__editor .jz_editor_layer {
  border: 0;
  background: rgba(0, 0, 0, 0.6);
  line-height: 70px;
  text-align: center;
}
.jz_editor_layer {
  display: none;
  position: absolute;
  width: 100%;
  height: 100%;
  border: 1px solid #5874d8;
  left: 0;
  top: 0;
  box-sizing: border-box;
}
.jz_img_item {
  display: inline-block;
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  vertical-align: middle;
}
img {
  max-width: 100%;
  vertical-align: top;
}
.jz_img:after {
  content: "";
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}
.jz_editor_del {
  width: 14px;
  height: 14px;
  position: absolute;
  right: -5px;
  top: -5px;
  background: url(/static/image/component.png) no-repeat -435px 0;
  cursor: pointer;
}
.jz_background__editor_item_jump {
  background-position: -982px -29px;
}
.jz_background__editor_item_jump,
.jz_background__editor_item_upload {
  display: inline-block;
  width: 30px;
  height: 30px;
  margin: 0 5px;
  border-radius: 50%;
  background-color: #333;
  vertical-align: middle;
  cursor: pointer;
  background-image: url(/static/image/component.png);
}
.jz_background__editor_item_upload {
  background-position: -1013px -29px;
}
.jz_background__editor_item_jump_new {
  background-position: -982px -29px;
}
.jz_background__editor_item_jump_new,
.jz_background__editor_item_upload {
  display: inline-block;
  width: 30px;
  height: 30px;
  margin: 0 5px;
  vertical-align: middle;
  cursor: pointer;
  background-image: url(/static/image/component.png);
}
.jz_background__editor:hover .jz_editor_layer {
  display: block;
}
.fileName {
  display: inline-block;
  font-size: 13px;
  color: #333;
  line-height: 34px;
  text-decoration: none;
  cursor: pointer;
  max-width: 250px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-left: 10px;
}
.fileName:hover {
  color: #696ad7;
}
.my_img_button_layer {
  position: relative;
}
.tips_left {
  display: inline-block;
  font-size: 13px;
  text-align: right;
  left: 16px;
  overflow: hidden;
  height: 32px;
  line-height: 34px;
  position: absolute;
  .icon_info {
    border: 1px solid #cfd3db;
    color: #cfd3db;
    width: 18px;
    font-size: 13px;
    height: 18px;
    display: inline-block;
    border-radius: 50%;
    text-align: center;
    line-height: 18px;
    cursor: pointer;
  }
  .icon_info_right {
    margin-left: -10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my_img_button/index.vue